<!--
 * @Author: Junjie
 * @Date: 2022-08-25 02:00:01
 * @LastEditTime: 2022-09-24 17:01:31
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/jeecg/IframeDrawer.vue
-->
<template>
  <a-drawer
    :closable="false"
    :title="title"
    :visible="visible"
    :width="width"
    @close="close"
    destroyOnClose
    placement="right"
  >
    <iframe-f-report-view :src="iframeSrc"></iframe-f-report-view>
  </a-drawer>
</template>

<script>

  import IframeFReportView from '@/components/layouts/IframeFReportView.vue';

  export default {
    name: 'IframeDrawer',
    components: {
      IframeFReportView
    },
    data () {
      return {
        title: "详情",
        width: 1000,
        visible: false,
        iframeSrc: ''
      }
    },
    methods: {
      show (src) {
        this.visible = true
        this.$nextTick(() => {
          this.iframeSrc = src;
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
    }
  }
</script>

<style lang="less" scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
  .drawer-footer {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>